<!--人文美育-视频库管理-->
<template>
    <div class="app-container" >
        <div class="base-create-container">
            <!--创建-->
            <div class="head-container">
                <div class="left-head-container" @click="backList">
                    <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#0d55a4" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                </div>
                <div class="right-head-container">{{museumName}}</div>
                <div class="left-head-container">
                    <el-input v-model="queryForm.courseName" placeholder="请输入课程名称" class="input-with-select">
                        <template #append>
                            <el-button type="primary" @click="handleQuery" style="background-color: #0d55a4;color: #fff" icon="el-icon-search" />
                        </template>
                    </el-input>
                </div>
            </div>
            <div class="info-container">
                <div class="book-item" v-for="item in courseList">
                    <div class="book-one" @click="viewCourse(item)">
                        <div class="book-img">
                            <img alt="" class="img-100" :src="item.courseCover">
                        </div>
                        <div class="book-title">
                            {{ item.courseName }}
                        </div>
                    </div>
                </div>

                <div class="div-100" v-if="courseList&&courseList.length===0">
                    <dataEmpty title="暂无课程" />
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {serviceUrl} from "@/utils/global";
import dataEmpty from "@/components/dataEmpty.vue";
import {listHumanityCourse} from "@/api/admin/humanityCourse";

export default {
    name: "museumCourseList",
    components: {dataEmpty},
    data() {
        return {
            serviceUrl,
            museumKey:'',
            museumName:'',
            queryForm:{
                museumKey:'',
                courseName:'',
            },
            courseList:[],
        }
    },
    computed: {},
    watch: {},
    created() {
        if (this.$route.query.museumkey) {
            this.museumKey = this.$route.query.museumkey;
            this.queryForm.museumKey = this.museumKey;
            if (this.museumKey === '1'){
                this.museumName = '恒岳·阅读拓展馆';
            }
            if (this.museumKey === '2'){
                this.museumName = '恒岳·科技艺术馆';
            }
            if (this.museumKey === '3'){
                this.museumName = '恒岳·非遗文化馆';
            }
            if (this.museumKey === '4'){
                this.museumName = '恒岳·劳动实践营';
            }
            if (this.museumKey === '5'){
                this.museumName = '恒岳·研学体验馆';
            }
            this.queryHumanityCourse();
        }
    },
    mounted(){

    },
    methods: {
        backList(){
            this.$router.push({
                path: "/humanityLibrary",
            });
        },
        handleQuery(){
            this.queryHumanityCourse();
        },
        viewCourse(item){
            this.$router.push({
                path: "/humanityCourseInfo",
                query: {
                    courseId: item.courseId,
                }
            });
        },
        queryHumanityCourse(){
            listHumanityCourse(this.queryForm).then(res => {
                if (res.data.code === 1) {
                    this.courseList = res.data.data;
                } else {
                    this.$message.error("请求出错");
                }
            })
        }

    }
}

</script>

<style scoped>
.base-create-container{
    width: 100%;
    height: calc(100vh - 85px);
    background-color: #fff;
    overflow-y: auto!important;
    box-sizing: border-box;
    font-family: sans-serif;
}
.head-container{
    width: 100%;
    height: 48px;
    display: flex;
}
.left-head-container{
    width: 250px;
    height: 44px;
    cursor: pointer;
    padding-left: 10px;
    padding-top: 9px;
}
.right-head-container{
    width: calc(100% - 500px);
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #0d55a4;
    line-height: 44px;
    font-weight: bold;
}
.info-container{
    width: 100%;
    height: calc(100% - 50px);
    display: flex;
    border-top: 1px solid #f1f1f1;
    flex-wrap: wrap!important;
}
.book-item{
    width: 25%;
    height: 200px;
    padding: 0 10px 10px 10px;
    box-sizing: border-box;
}
.book-one{
    width: 100%;
    height: 180px;
    box-shadow: var(--el-box-shadow-light);
}
.book-one:hover{
    border: 1.5px solid #0d55a4!important;
    color: #0d55a4!important;
    font-weight: bold;
}
.book-img{
    width: 100%;
    height: 140px;
    cursor: pointer;
}
.book-title{
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    padding: 0 5px 5px 5px;
    cursor: pointer;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-family: sans-serif;
}
</style>